import React, { useState } from 'react';
import { Box, Paper, Tabs, Tab, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Typography } from '@mui/material';

const ReportsTabs = ({ outstanding, sales, categoryComp,targetsales, currentFY, previousFY }) => {
    const [tabIndex, setTabIndex] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    const tabLabels = ['Outstanding', 'Sales Comparison', 'Division Wise Sales', 'Target & Sales'];

    return (
        <Box sx={{ width: '100%', color: 'white', py: 2,}}> {/* py reduced */}

            {/* Horizontal Tabs */}
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 1 }}> {/* mb reduced */}
                <Tabs
                    value={tabIndex}
                    onChange={handleTabChange}
                    variant="fullWidth"
                    TabIndicatorProps={{ style: { backgroundColor: 'red', height: 3 } }}
                    sx={{
                        width: '100%',
                        minHeight: 36,
                        '& .MuiTab-root': {
                            minWidth: 0,
                            maxWidth: 'none',
                            px: { xs: 0.5, sm: 1, md: 1.5 },
                            fontSize: { xs: '0.72rem', sm: '0.84rem', md: '0.95rem' },
                            whiteSpace: 'normal',
                            lineHeight: 1.2
                        }
                    }}
                >
                    {tabLabels.map((label, index) => (
                        <Tab
                            key={index}
                            label={label}
                            sx={{
                                color: 'white',
                                fontWeight: 'bold',
                                textTransform: 'none',
                                minHeight: 30, // reduced height
                                py: 0.5, // reduce vertical padding
                                '&.Mui-selected': { color: 'red' },
                            }}
                        />
                    ))}
                </Tabs>
            </Box>

            {/* Tab Content */}
            <Box sx={{ display: 'flex', justifyContent: 'center', px: { xs: 0.5, sm: 2 } }}>
                <Box sx={{ width: '100%', maxWidth: 1000 }}>

                    {tabIndex === 0 && (
                        <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}> {/* p reduced */}
                            <TableContainer>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                            <TableCell sx={{ fontWeight: 'bold' }}>Day Slots</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>Bill Amt (Lakh)</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {outstanding.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{row.daySlot}</TableCell>
                                                <TableCell>{row.billAmountDisplay || row.billAmount}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    )}

                    {tabIndex === 1 && (
                        <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}>
                            <TableContainer>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow sx={{ backgroundColor: '#f5f5f5', py: 0 }}>
                                            <TableCell sx={{ fontWeight: 'bold', py: 0.5, px: 1 }}>Month</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', py: 0.5, px: 1 }} align="center" colSpan={2}>{previousFY}</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', py: 0.5, px: 1 }} align="center" colSpan={2}>{currentFY}</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: '#f5f5f5', py: 0 }}>
                                            <TableCell sx={{ py: 0.5, px: 1 }}></TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', py: 0.5, px: 1 }} align="center">Qty (Mtr)</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', py: 0.5, px: 1 }} align="center">Amt (Lakh)</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', py: 0.5, px: 1 }} align="center">Qty (Mtr)</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', py: 0.5, px: 1 }} align="center">Amt (Lakh)</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {sales.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{row.month}</TableCell>
                                                <TableCell
                                                    sx={{
                                                        textAlign: "center",
                                                        backgroundColor: row.higherYear === 'previous' ? '#d9fdd3' : 'inherit',
                                                        fontWeight: row.higherYear === 'previous' ? 700 : 500
                                                    }}
                                                >
                                                    {row.qty2Display}
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        textAlign: "center",
                                                        backgroundColor: row.higherYear === 'previous' ? '#d9fdd3' : 'inherit',
                                                        color: row.higherYear === 'previous' ? '#166534' : 'inherit',
                                                        fontWeight: row.higherYear === 'previous' ? 700 : 500
                                                    }}
                                                >
                                                    {row.amt2Display}
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        textAlign: "center",
                                                        backgroundColor: row.higherYear === 'current' ? '#d9fdd3' : 'inherit',
                                                        fontWeight: row.higherYear === 'current' ? 700 : 500
                                                    }}
                                                >
                                                    {row.qty1Display}
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        textAlign: "center",
                                                        backgroundColor: row.higherYear === 'current' ? '#d9fdd3' : 'inherit',
                                                        color: row.higherYear === 'current' ? '#166534' : 'inherit',
                                                        fontWeight: row.higherYear === 'current' ? 700 : 500
                                                    }}
                                                >
                                                    {row.amt1Display}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    )}

                    {tabIndex === 2 && (
                        <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}>
                            <TableContainer>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow sx={{ backgroundColor: '#f5f5f5', py: 0 }}>
                                            <TableCell sx={{ fontWeight: 'bold', py: 0.5, px: 1 }}>Division</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', py: 0.5, px: 1 }} align="center" colSpan={2}>{previousFY}</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', py: 0.5, px: 1 }} align="center" colSpan={2}>{currentFY}</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: '#f5f5f5', py: 0 }}>
                                            <TableCell sx={{ py: 0.5, px: 1 }}></TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', py: 0.5, px: 1 }} align="center">Qty (Mtr)</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', py: 0.5, px: 1 }} align="center">Amt (Lakh)</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', py: 0.5, px: 1 }} align="center">Qty (Mtr)</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', py: 0.5, px: 1 }} align="center">Amt (Lakh)</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {categoryComp.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{row.category}</TableCell>
                                                <TableCell
                                                    sx={{
                                                        textAlign: "center",
                                                        backgroundColor: row.higherYear === 'previous' ? '#d9fdd3' : 'inherit',
                                                        fontWeight: row.higherYear === 'previous' ? 700 : 500
                                                    }}
                                                >
                                                    {row.qty2Display || row.qty2?.toFixed?.(2) || '0.00'}
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        textAlign: "center",
                                                        backgroundColor: row.higherYear === 'previous' ? '#d9fdd3' : 'inherit',
                                                        color: row.higherYear === 'previous' ? '#166534' : 'inherit',
                                                        fontWeight: row.higherYear === 'previous' ? 700 : 500
                                                    }}
                                                >
                                                    {row.amt2Display || row.amt2?.toFixed?.(2) || '0.00'}
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        textAlign: "center",
                                                        backgroundColor: row.higherYear === 'current' ? '#d9fdd3' : 'inherit',
                                                        fontWeight: row.higherYear === 'current' ? 700 : 500
                                                    }}
                                                >
                                                    {row.qty1Display || row.qty1.toFixed(2)}
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        textAlign: "center",
                                                        backgroundColor: row.higherYear === 'current' ? '#d9fdd3' : 'inherit',
                                                        color: row.higherYear === 'current' ? '#166534' : 'inherit',
                                                        fontWeight: row.higherYear === 'current' ? 700 : 500
                                                    }}
                                                >
                                                    {row.amt1Display || row.amt1.toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    )}

                    {tabIndex === 3 && (
                        <Paper sx={{ p: 4, borderRadius: 2, boxShadow: 3, textAlign: 'center' }}>
                            <TableContainer>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow sx={{ backgroundColor: '#f5f5f5', py: 0 }}>
                                            <TableCell sx={{ fontWeight: 'bold', py: 0.5, px: 1 }}>Party Name</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', py: 0.5, px: 1 }} align="center" colSpan={2}>{previousFY}</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', py: 0.5, px: 1 }} align="center" colSpan={2}>{currentFY}</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ backgroundColor: '#f5f5f5', py: 0 }}>
                                            <TableCell sx={{ py: 0.5, px: 1 }}></TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', py: 0.5, px: 1 }} align="center">Target Amt</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', py: 0.5, px: 1 }} align="center">Sale (Lakh)</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', py: 0.5, px: 1 }} align="center">Target Amt</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold', py: 0.5, px: 1 }} align="center">Sale (Lakh)</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {targetsales.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{row.partyName}</TableCell>
                                                <TableCell
                                                    sx={{
                                                        textAlign: "center",
                                                        backgroundColor: row.higherYear === 'previous' ? '#d9fdd3' : 'inherit',
                                                        fontWeight: row.higherYear === 'previous' ? 700 : 500
                                                    }}
                                                >
                                                    {row.target2Display || row.target2?.toFixed?.(2) || '0.00'}
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        textAlign: "center",
                                                        backgroundColor: row.higherYear === 'previous' ? '#d9fdd3' : 'inherit',
                                                        color: row.higherYear === 'previous' ? '#166534' : 'inherit',
                                                        fontWeight: row.higherYear === 'previous' ? 700 : 500
                                                    }}
                                                >
                                                    {row.sale2Display || row.sale2?.toFixed?.(2) || '0.00'}
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        textAlign: "center",
                                                        backgroundColor: row.higherYear === 'current' ? '#d9fdd3' : 'inherit',
                                                        fontWeight: row.higherYear === 'current' ? 700 : 500
                                                    }}
                                                >
                                                    {row.target1Display || row.target1.toFixed(2)}
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        textAlign: "center",
                                                        backgroundColor: row.higherYear === 'current' ? '#d9fdd3' : 'inherit',
                                                        color: row.higherYear === 'current' ? '#166534' : 'inherit',
                                                        fontWeight: row.higherYear === 'current' ? 700 : 500
                                                    }}
                                                >
                                                    {row.sale1Display || row.sale1.toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    )}

                    {/* {tabIndex === 4 && (
                        <Paper sx={{ p: 4, borderRadius: 2, boxShadow: 3, textAlign: 'center' }}>
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                Schem - Coming Soon
                            </Typography>
                        </Paper>
                    )} */}

                </Box>
            </Box>
        </Box>
    );
};

export default ReportsTabs;
